import React, {Component} from 'react';

import {connect} from 'react-redux';

import ActionBar from '../../components/ActionBar';
import ActionBarItem from '../../components/ActionBarItem';
import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';

import ConversionCondition from './ConversionCondition';

import validator from '../../helpers/validator';

import { isAllowed } from '../../helpers/auth';
import { Permissions } from '../../helpers/permissions';

import * as ArchitectActions from '../../actions/architectActions';
import * as CoreActions from '../../actions/coreActions';

import classes from './ConversionForm.module.css';

const rawDataTypes = [
    {
        id:   'boolean',
        name: 'Boolean'
    },
    {
        id:   'integer',
        name: 'Integer'
    },
    {
        id:   'float',
        name: 'Float'
    },
    {
        id:   'text',
        name: 'Text'
    }
];

const displayDataTypes = [];

class ConversionAddForm extends Component {
    state = {
        conditions:          [],
        displayDataDisabled: true,
        formIsValid:         false,
        formControls:        {
            conversionName: {
                value:           '',
                placeholder:     'Conversion Name',
                valid:           false,
                touched:         false,
                message:         '',
                validationRules: {
                    isRequired: true,
                    maxLength:  45
                }
            },
            rawDataType: {
                value:           '',
                placeholder:     'Raw Data Type',
                valid:           false,
                touched:         false,
                message:         '',
                validationRules: {

                }
            },
            displayDataType: {
                value:           '',
                placeholder:     'Display Data Type',
                valid:           false,
                touched:         false,
                message:         '',
                validationRules: {

                }
            },
            defaultResult: {
                value:           '',
                placeholder:     'Default Result',
                valid:           false,
                touched:         false,
                message:         '',
                validationRules: {

                }
            }
        },
        saveInProcess: false
    }

    updateControls = (update, event) => {
        const {name} = event.target;
        const updatedControls = {...this.state.formControls};

        updatedControls[name].value = update;

        this.setState({
            formControls: updatedControls
        });
    }

    handleValidation = event => {
        const validatedState = validator(this.state, event);

        this.setState({
            formControls: validatedState.updatedControls,
            formIsValid:  validatedState.formIsValid
        });
    }

    handleChange = event => {
        const {value} = event.target;

        this.updateControls(value, event);
    }

    handleRawDataChange = event => {
        const {value} = event.target;

        const updatedControls = {
            ...this.state.formControls
        };

        updatedControls.displayDataType.value = '';
        updatedControls.displayDataType.touched = false;
        updatedControls.displayDataType.valid = false;

        updatedControls.defaultResult.value = '';
        updatedControls.defaultResult.touched = false;
        updatedControls.defaultResult.valid = false;

        displayDataTypes.splice(0, displayDataTypes.length);

        switch (value) {
            case 'boolean':
            case 'integer':
                displayDataTypes.push(
                    {
                        id:   'boolean',
                        name: 'Boolean'
                    },
                    {
                        id:   'integer',
                        name: 'Integer'
                    }
                );
                break;
            case 'float':
                displayDataTypes.push(
                    {
                        id:   'boolean',
                        name: 'Boolean'
                    }
                );
                break;
            case 'text':
                displayDataTypes.push(
                    {
                        id:   'boolean',
                        name: 'Boolean'
                    },
                    {
                        id:   'integer',
                        name: 'Integer'
                    },
                    {
                        id:   'text',
                        name: 'Text'
                    }
                );
                break;
            default:
                break;
        }

        this.setState({
            displayDataDisabled: false,
            formControls:        updatedControls
        });

        this.updateControls(value, event);
    }

    handleSave = async () => {
        this.setState({saveInProcess: true});
        const {companyInfo, createConversion,  setProgressBarLoading} = this.props;
        let isCreated;

        const body = {
            'name':            this.state.formControls.conversionName.value,
            'rawDataType':     this.state.formControls.rawDataType.value,
            'displayDataType': this.state.formControls.displayDataType.value,
            'conditions':      [...this.state.conditions],
            'defaultResult':   this.state.formControls.defaultResult.value
        };

        setProgressBarLoading(true);

        isCreated = await createConversion(companyInfo, body);

        setProgressBarLoading(false);

        if (isCreated) {
            this.handleReset();
        }
        this.setState({saveInProcess: false});
    }

    handleAddCondition = () => {
        let conditions = [...this.state.conditions];

        conditions = [...conditions, {condition: '', result: ''}];

        this.setState({
            conditions
        });
    }

    handleConditionChange = (model, index) => {
        let conditions = [...this.state.conditions];

        conditions[index] = {
            condition: model.condition.value,
            result:    model.result.value
        };

        this.setState({
            conditions
        });
    }

    handleReset = () => {
        let conditions = [...this.state.conditions];

        const updatedControls = {
            ...this.state.formControls
        };

        conditions.splice(0, conditions.length);

        updatedControls.conversionName.value = '';
        updatedControls.conversionName.touched = false;
        updatedControls.conversionName.valid = false;

        updatedControls.rawDataType.value = '';
        updatedControls.rawDataType.touched = false;
        updatedControls.rawDataType.valid = false;

        updatedControls.displayDataType.value = '';
        updatedControls.displayDataType.touched = false;
        updatedControls.displayDataType.valid = false;

        updatedControls.defaultResult.value = '';
        updatedControls.defaultResult.touched = false;
        updatedControls.defaultResult.valid = false;

        this.setState({
            conditions,
            displayDataDisabled: true,
            formControls:        updatedControls,
            formIsValid:         false,
            saveInProcess:       false
        });
    }

    preventCharacters = event => {
        const invalidCharacters = ['.', '-', '+', 'e'];

        if (invalidCharacters.indexOf(event.key) > -1) {
            event.preventDefault();
        }
    }

    renderDefaultResult = type => {
        switch (type) {
            case 'boolean':
                return (
                    <React.Fragment>
                        <Select
                            value={this.state.formControls.defaultResult.value}
                            onChange={this.handleChange}
                            className={classes.select}
                            inputProps={{
                                name:     'defaultResult',
                                id:       'defaultResult',
                                onChange: this.handleValidation
                            }}
                        >
                            <MenuItem
                                value={true}
                            >
                                True
                            </MenuItem>
                            <MenuItem
                                value={false}
                            >
                                False
                            </MenuItem>
                        </Select>
                        {!this.state.formControls.defaultResult.valid &&
                         this.state.formControls.defaultResult.touched && <FormHelperText className={classes.error}>{this.state.formControls.defaultResult.message}</FormHelperText>}
                    </React.Fragment>
                );
            case 'integer':
                return (
                    <React.Fragment>
                        <Input
                            id="defaultResult"
                            name="defaultResult"
                            type="number"
                            inputProps={{
                                min:       0,
                                onKeyDown: event => { this.preventCharacters(event); },
                                onChange:  this.handleValidation
                            }}
                            value={this.state.formControls.defaultResult.value}
                            onChange={this.handleChange}
                            classes={{
                                underline: classes.cssUnderline,
                                root:      classes.input
                            }}
                        />
                        {!this.state.formControls.defaultResult.valid &&
                         this.state.formControls.defaultResult.touched && <FormHelperText className={classes.error}>{this.state.formControls.defaultResult.message}</FormHelperText>}
                    </React.Fragment>
                );
            case 'text':
                return (
                    <React.Fragment>
                        <Input
                            id="defaultResult"
                            name="defaultResult"
                            value={this.state.formControls.defaultResult.value}
                            onChange={this.handleChange}
                            inputProps={{
                                onFocus: this.handleValidation
                            }}
                            classes={{
                                underline: classes.cssUnderline,
                                root:      classes.input
                            }}
                        />
                        {!this.state.formControls.defaultResult.valid &&
                         this.state.formControls.defaultResult.touched && <FormHelperText className={classes.error}>{this.state.formControls.defaultResult.message}</FormHelperText>}
                    </React.Fragment>
                );
            default:
                return (
                    <React.Fragment>
                        <Input
                            id="defaultResult"
                            name="defaultResult"
                            value={this.state.formControls.defaultResult.value}
                            disabled
                            classes={{
                                underline: classes.cssUnderline,
                                root:      classes.input
                            }}
                        />
                    </React.Fragment>
                );
        }
    }

    render() {
        const { currentScopes } = this.props;

        const {
            conditions,
            displayDataDisabled,
            formControls,
            formIsValid
        } = this.state;

        const dataTypesAreValid = formControls.rawDataType.valid && formControls.displayDataType.valid && formControls.defaultResult.valid;

        const isFullArchitectAllowed = isAllowed(currentScopes, Permissions('architectFull'));

        return (
            <div className={classes.conversionForm}>
                <div className={classes.header}>
                    <h2 className={classes.PanelHeader}>
                        <img src="/assets/images/conversionIconColor.svg" alt="new conversion icon" />
                        <span>Conversion Builder</span>
                    </h2>
                </div>
                <div className={classes.formContainer}>
                    <ActionBar>
                        <ActionBarItem
                            type="refresh"
                            onClick={this.handleReset}
                            hidden={!isFullArchitectAllowed}
                            disabled={this.state.saveInProcess}
                        >
                            Reset Form
                        </ActionBarItem>
                        <ActionBarItem
                            type="add"
                            onClick={this.handleAddCondition}
                            disabled={!dataTypesAreValid || this.state.saveInProcess}
                            hidden={!isFullArchitectAllowed}
                        >
                            Add Condition
                        </ActionBarItem>
                        <ActionBarItem
                            type="save"
                            onClick={this.handleSave}
                            disabled={!formIsValid || this.state.saveInProcess}
                            hidden={!isFullArchitectAllowed}
                        >
                            Save Conversion
                        </ActionBarItem>
                    </ActionBar>
                    <div className={classes.inputs}>
                        <FormControl className={classes.inputWrapper}>
                            <InputLabel
                                htmlFor="conversionName"
                                classes={{
                                    root:    classes.label,
                                    focused: classes.labelFocused
                                }}
                            >
                                {this.state.formControls.conversionName.placeholder}
                            </InputLabel>
                            <Input
                                id="conversionName"
                                name="conversionName"
                                value={this.state.formControls.conversionName.value}
                                onChange={this.handleChange}
                                inputProps={{
                                    onBlur: this.handleValidation
                                }}
                                classes={{
                                    underline: classes.cssUnderline,
                                    root:      classes.input
                                }}
                            />
                            {!this.state.formControls.conversionName.valid &&
                             this.state.formControls.conversionName.touched && <FormHelperText className={classes.error}>{this.state.formControls.conversionName.message}</FormHelperText>}
                        </FormControl>
                        <div className={classes.halfWidthInputContainer}>
                            <FormControl className={classes.halfWidthInputWrapper}>
                                <InputLabel
                                    htmlFor="rawDataType"
                                    classes={{
                                        root:    classes.label,
                                        focused: classes.labelFocused
                                    }}
                                >
                                    {this.state.formControls.rawDataType.placeholder}
                                </InputLabel>
                                <Select
                                    value={this.state.formControls.rawDataType.value}
                                    onChange={this.handleRawDataChange}
                                    className={classes.select}
                                    inputProps={{
                                        name:   'rawDataType',
                                        id:     'rawDataType',
                                        onBlur: this.handleValidation
                                    }}
                                >
                                    {
                                        rawDataTypes.map(type =>
                                            <MenuItem
                                                key={type.id}
                                                value={type.id}
                                            >
                                                {type.name}
                                            </MenuItem>
                                        )
                                    }
                                </Select>
                                {!this.state.formControls.rawDataType.valid &&
                                 this.state.formControls.rawDataType.touched && <FormHelperText className={classes.error}>{this.state.formControls.rawDataType.message}</FormHelperText>}
                            </FormControl>
                            <FormControl className={classes.halfWidthInputWrapper}>
                                <InputLabel
                                    htmlFor="displayDataType"
                                    classes={{
                                        root:    classes.label,
                                        focused: classes.labelFocused
                                    }}
                                >
                                    {this.state.formControls.displayDataType.placeholder}
                                </InputLabel>
                                <Select
                                    value={this.state.formControls.displayDataType.value}
                                    onChange={this.handleChange}
                                    className={classes.select}
                                    disabled={displayDataDisabled}
                                    inputProps={{
                                        name:   'displayDataType',
                                        id:     'displayDataType',
                                        onBlur: this.handleValidation
                                    }}
                                >
                                    {
                                        displayDataTypes.map(type =>
                                            <MenuItem
                                                key={type.id}
                                                value={type.id}
                                            >
                                                {type.name}
                                            </MenuItem>
                                        )
                                    }
                                </Select>
                                {!this.state.formControls.displayDataType.valid &&
                                 this.state.formControls.displayDataType.touched && <FormHelperText className={classes.error}>{this.state.formControls.displayDataType.message}</FormHelperText>}
                            </FormControl>
                        </div>
                        <h3>Conditions</h3>
                        {
                            conditions.map((element, index) => (
                                <ConversionCondition
                                    onModelChange={this.handleConditionChange}
                                    index={index}
                                    key={index}
                                    rawDataType={formControls.rawDataType.value}
                                    displayDataType={formControls.displayDataType.value}
                                />
                            ))
                        }
                        <div className={`${classes.halfWidthInputContainer} ${classes.rightAligned}`}>
                            <FormControl className={classes.halfWidthInputWrapper}>
                                <InputLabel
                                    htmlFor="defaultResult"
                                    classes={{
                                        root:    classes.label,
                                        focused: classes.labelFocused
                                    }}
                                >
                                    {this.state.formControls.defaultResult.placeholder}
                                </InputLabel>
                                {this.renderDefaultResult(formControls.displayDataType.value)}
                            </FormControl>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        companyInfo:   state.companyInfo,
        currentScopes: state.core.currentScopes
    };
};

const mapDispatchToProps = {
    ...ArchitectActions,
    ...CoreActions
};

export default connect(mapStateToProps, mapDispatchToProps)(ConversionAddForm);
